import { Topbar } from '../../components/Topbar/Topbar';
import { Alert, Button, Container, Form } from 'react-bootstrap';
import { Footer } from '../../components/Footer/Footer';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { Redirect } from 'react-router-dom';
import { ChangeEvent, FormEvent, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { Title } from '../../components/Title/Title';
import { useTranslation } from 'react-i18next';
import { useGaming } from '../../../contexts/GamingContext';

const CollaborateComponent = () => {
  const { staticData, requestCollaboration, currentUser, userDataFmt } = useFirebase();
  const { track } = useGaming();
  const { t } = useTranslation();

  const getInitialState = () => ({
    requestType: '',
    requestBody: '',
    requestName: userDataFmt ? `${userDataFmt.profile?.formData?.nome || ''} ${userDataFmt.profile?.formData?.cognome || ''}`.trim() : '',
    requestEmail: currentUser?.email || '',
  });

  const [request, setRequest] = useState(getInitialState());
  const requestTypeOptions = [t('collaborate.labels.role1'), t('collaborate.labels.role2'), t('collaborate.labels.role3')];

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const onRequestSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    requestCollaboration(request)
      .then((res) => {
        if (res) {
          setSuccess(true);
          setRequest(getInitialState());
          track('WORK_WITH_US', {});
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  if (!staticData.SHOW_COLLABORATE) return <Redirect to={'/'} />;

  return (
    <>
      <Title>{t('labels.lavoraConNoi')}</Title>

      <div style={{ marginBottom: '72px' }}>
        <div style={{ backgroundColor: '#141414', position: 'fixed', top: '0', left: '0', right: '0', zIndex: 100 }}>
          <Topbar />
        </div>
      </div>

      <Container className={'my-5'}>
        <div className={'display-4 mb-3'}>{t('labels.lavoraConNoi')}</div>
        <p>{t('collaborate.labels.lavoraConNoiDescrizione', { title: process.env.REACT_APP_TITLE })}</p>
        <p>{t('collaborate.labels.tiAspettiamo', { title: process.env.REACT_APP_TITLE })}</p>

        <div className={'d-flex flex-column align-items-center'}>
          {success && (
            <Alert variant={'success'} className={'text-center'} style={{ width: '100%', maxWidth: '500px' }}>
              {t('collaborate.labels.richiestaInviata')}
            </Alert>
          )}

          <Form onSubmit={onRequestSubmit} style={{ width: '100%', maxWidth: '500px' }}>
            <Form.Group>
              <Form.Label>{t('collaborate.labels.seiUn')}</Form.Label>
              <Form.Control
                as={'select'}
                required
                disabled={loading}
                value={request.requestType}
                onChange={(e: ChangeEvent<HTMLSelectElement>) => setRequest({ ...request, requestType: e.target.value })}
              >
                <option disabled value={''}>
                  {t('labels.selezionaValore')}
                </option>
                {requestTypeOptions.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group>
              <Form.Control
                required
                disabled={loading}
                value={request.requestName}
                onChange={(e) => setRequest({ ...request, requestName: e.target.value })}
                placeholder={t('collaborate.labels.placeholderNome')}
              />
            </Form.Group>

            <Form.Group>
              <Form.Control
                required
                type={'email'}
                disabled={loading}
                value={request.requestEmail}
                onChange={(e) => setRequest({ ...request, requestEmail: e.target.value })}
                placeholder={t('labels.email')}
              />
            </Form.Group>

            <Form.Group>
              <Form.Control
                as={'textarea'}
                required
                rows={6}
                value={request.requestBody}
                onChange={(e) => setRequest({ ...request, requestBody: e.target.value })}
                placeholder={t('collaborate.labels.placeholderRichiesta')}
                disabled={loading}
              />
            </Form.Group>
            <div className={'d-flex justify-content-end'}>
              <Button type={'submit'} variant={'primary'} disabled={loading}>
                <FontAwesomeIcon spin={loading} icon={loading ? faCircleNotch : faPaperPlane} className={'mr-2'} />
                {loading ? t('labels.invioInCorso') : t('labels.invia')}
              </Button>
            </div>
          </Form>
        </div>
      </Container>

      <Footer />
    </>
  );
};

export default CollaborateComponent;
